import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import BusinessIcon from '@material-ui/icons/Business';
import HomeIcon from '@material-ui/icons/Home';
import GroupIcon from '@material-ui/icons/Group';
import BuildIcon from '@material-ui/icons/Build';
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import {getMyInfo} from "../../auth";
import {e2p} from "../../utils/utils";
import ChargeModal from "../ChargeModal";
import Logo from "../../assets/images/logo2-removebg-preview.png";

const useStyles = makeStyles((theme) => ({
    drawer: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    listItem: {
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.8rem',
            padding: '8px 16px',
        },
    },
    listItemIcon: {
        [theme.breakpoints.down('sm')]: {
            minWidth: '32px',
        },
    },
    listItemText: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '8px',
        },
    },
    drawerPaper: {
        // width: drawerWidth,
    },
    wallet: {
        backgroundColor: '#ffe052',
        padding: '16px',
        textAlign: 'center',
    },
    toolbar: theme.mixins.toolbar,
}));

const SwipeableTemporaryDrawer = () => {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);
    const [info, setInfo] = useState(null);
    const [chargeModalOpen, setChargeModalOpen] = useState(false);
    
    const toggleDrawer = (open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setIsOpen(open);
    };
    
    useEffect(() => {
        async function fetchData() {
            const response = await getMyInfo();
            setInfo(response.data.data);
        }
        
        fetchData();
    }, []);
    
    const handleOpenChargeModal = () => {
        setChargeModalOpen(true);
    }
    
    return (
        <div className="container">
            <SwipeableDrawer
                className={classes.drawer}
                open={isOpen}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                classes={{
                    paper: classes.drawerPaper,
                }}
                anchor="right"
            >
                <div className={classes.toolbar}/>
                <List>
                    <Link
                        to="/user-panel"
                        style={{textDecoration: 'none', color: 'inherit'}}
                        className="d-block d-lg-none d-xl-none"
                    >
                        {info?.role !== 'admin' &&
                            <ListItem button className={classes.wallet} onClick={handleOpenChargeModal}>
                                <ListItemIcon>
                                    <AccountBalanceWalletIcon/>
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <div className="d-flex">
                                        <span className="fw-bold mx-2">
                                          {e2p(info?.company?.wallet?.balance.toLocaleString())} ریال
                                        </span>
                                        </div>
                                    }
                                />
                            </ListItem>
                        }
                    </Link>
                    <Link to="/user-panel" style={{textDecoration: 'none', color: 'inherit'}}>
                        <ListItem button onClick={toggleDrawer(false)}>
                            <ListItemIcon>
                                <HomeIcon/>
                            </ListItemIcon>
                            <ListItemText primary="صفحه اصلی"/>
                        </ListItem>
                    </Link>
                    <Link to="/reports" style={{textDecoration: 'none', color: 'inherit'}}>
                        <ListItem button onClick={toggleDrawer(false)}>
                            <ListItemIcon>
                                <BuildIcon/>
                            </ListItemIcon>
                            <ListItemText primary="گزارشات"/>
                        </ListItem>
                    </Link>
                    {info?.role === 'admin' &&
                        <Link to="/companies" style={{textDecoration: 'none', color: 'inherit'}}>
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <BusinessIcon/>
                                </ListItemIcon>
                                <ListItemText primary="صافکاری ها"/>
                            </ListItem>
                        </Link>
                    }
                    {(info?.role === 'admin' || info?.role === 'company') &&
                        <Link to="/factories" style={{textDecoration: 'none', color: 'inherit'}}>
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <HomeIcon/>
                                </ListItemIcon>
                                <ListItemText primary="شعبه ها"/>
                            </ListItem>
                        </Link>
                    }
                    {(info?.role === 'admin' || info?.role === 'company') &&
                        <Link to="/users" style={{textDecoration: 'none', color: 'inherit'}}>
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <GroupIcon/>
                                </ListItemIcon>
                                <ListItemText primary="کاربران"/>
                            </ListItem>
                        </Link>
                    }
                    {(info?.role === 'admin' || info?.role === 'company' || info?.role === 'factory') &&
                        <Link to="/workers" style={{textDecoration: 'none', color: 'inherit'}}>
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <GroupIcon/>
                                </ListItemIcon>
                                <ListItemText primary="صافکار / نقاش"/>
                            </ListItem>
                        </Link>
                    }
                    {info?.role !== 'admin' &&
                        <Link to="/transactions" style={{textDecoration: 'none', color: 'inherit'}}>
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <ReceiptLongIcon/>
                                </ListItemIcon>
                                <ListItemText primary="تراکنش ها"/>
                            </ListItem>
                        </Link>
                    }
                    {info?.role === 'admin' &&
                        <Link to="/admin/transactions" style={{textDecoration: 'none', color: 'inherit'}}>
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <ReceiptLongIcon/>
                                </ListItemIcon>
                                <ListItemText primary="تراکنش‌ها"/>
                            </ListItem>
                        </Link>
                    }
                    <Link to="/user-panel" style={{textDecoration: 'none', color: 'inherit'}}>
                        <div className="w-100 justify-content-center text-center mt-3">
                            <a className="d-flex w-auto mx-5" href="/user-panel">
                                <p className="my-auto fw-bold fs-6 text-dark mx-0">صــــاف یـــــار</p>
                                <div className="align-text-center mx-0" style={{height: '3rem'}}>
                                    <img src={Logo} alt="logo" className=""
                                         style={{minWidth: '100%', maxHeight: '100%'}}/>
                                </div>
                            </a>
                        </div>
                    </Link>
                    
                </List>
            </SwipeableDrawer>
            <IconButton onClick={toggleDrawer(true)}>
                <MenuIcon/>
            </IconButton>
            <div className="menu-inner-shadow"></div>
            <ChargeModal
                isOpen={chargeModalOpen}
                onClose={() => setChargeModalOpen(false)}
                url={'/wallet/zibal/payment'}
            />
        </div>
    );
};

export default SwipeableTemporaryDrawer;
